import { ProductFormData } from 'mk2/apps/bazaar/components/ProductCreateEditForm';
import { QualityCounts } from 'mk2/apps/bazaar/schemas';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';
import { Action } from 'redux';

export interface EditProductLoadApiAction extends Action {
    readonly slug: string;
}

export const EDIT_PRODUCT_LOAD_API_REQUEST = 'EDIT_PRODUCT_LOAD_API_REQUEST';

export interface EditProductLoadApiRequestAction extends EditProductLoadApiAction, APIRequestAction {
    readonly type: typeof EDIT_PRODUCT_LOAD_API_REQUEST;
}

export interface EditProductLoadApiNormalizedResponse extends NormalizedResponse {
    readonly result: {
        product: number;
    };
}

export const EDIT_PRODUCT_LOAD_API_SUCCESS = 'EDIT_PRODUCT_LOAD_API_SUCCESS';

export interface EditProductLoadApiSuccessAction
    extends EditProductLoadApiAction,
        APISuccessAction<EditProductLoadApiNormalizedResponse> {
    readonly type: typeof EDIT_PRODUCT_LOAD_API_SUCCESS;
    readonly correctedFields: string[];
    readonly qualityCounts: QualityCounts;
}

export const EDIT_PRODUCT_LOAD_API_FAILURE = 'EDIT_PRODUCT_LOAD_API_FAILURE';

export interface EditProductLoadApiFailureAction extends EditProductLoadApiAction, APIFailureAction {
    readonly type: typeof EDIT_PRODUCT_LOAD_API_FAILURE;
}

export const editProductLoadApi = {
    request: (slug: string): EditProductLoadApiRequestAction => ({
        type: EDIT_PRODUCT_LOAD_API_REQUEST,
        slug,
    }),
    success: (
        slug: string,
        correctedFields: string[],
        qualityCounts: QualityCounts,
        response: EditProductLoadApiNormalizedResponse,
    ): EditProductLoadApiSuccessAction => ({
        type: EDIT_PRODUCT_LOAD_API_SUCCESS,
        slug,
        correctedFields,
        qualityCounts,
        response,
    }),
    failure: (slug: string, error: any): EditProductLoadApiFailureAction => ({
        type: EDIT_PRODUCT_LOAD_API_FAILURE,
        slug,
        error,
    }),
};

export const EDIT_PRODUCT_LOAD = 'EDIT_PRODUCT_LOAD';

export interface EditProductLoadAction extends EditProductLoadApiAction {
    readonly type: typeof EDIT_PRODUCT_LOAD;
}

export const editProductLoad = (slug: string): EditProductLoadAction => ({
    type: EDIT_PRODUCT_LOAD,
    slug,
});

export const EDIT_PRODUCT_SELECT_PROPERTY = 'EDIT_PRODUCT_SELECT_PROPERTY';

export interface EditProductSelectPropertyAction extends Action {
    readonly type: typeof EDIT_PRODUCT_SELECT_PROPERTY;
    readonly property: string;
}

export const editProductSelectProperty = (property: string): EditProductSelectPropertyAction => ({
    type: EDIT_PRODUCT_SELECT_PROPERTY,
    property,
});

export interface EditProductSaveApiAction extends Action {
    readonly productId: number;
    readonly data: ProductFormData;
}

export const EDIT_PRODUCT_SAVE_API_REQUEST = 'EDIT_PRODUCT_SAVE_API_REQUEST';

export interface EditProductSaveApiRequestAction extends EditProductSaveApiAction, APIRequestAction {
    readonly type: typeof EDIT_PRODUCT_SAVE_API_REQUEST;
}

export interface EditProductSaveApiNormalizedResponse extends NormalizedResponse {
    readonly result: {
        product: number;
    };
}

export const EDIT_PRODUCT_SAVE_API_SUCCESS = 'EDIT_PRODUCT_SAVE_API_SUCCESS';

export interface EditProductSaveApiSuccessAction
    extends EditProductSaveApiAction,
        APISuccessAction<EditProductSaveApiNormalizedResponse> {
    readonly type: typeof EDIT_PRODUCT_SAVE_API_SUCCESS;
}

export const EDIT_PRODUCT_SAVE_API_FAILURE = 'EDIT_PRODUCT_SAVE_API_FAILURE';

export interface EditProductSaveApiFailureAction extends EditProductSaveApiAction, APIFailureAction {
    readonly type: typeof EDIT_PRODUCT_SAVE_API_FAILURE;
}

export const editProductSaveApi = {
    request: (productId: number, data: ProductFormData): EditProductSaveApiRequestAction => ({
        type: EDIT_PRODUCT_SAVE_API_REQUEST,
        productId,
        data,
    }),
    success: (
        productId: number,
        data: ProductFormData,
        response: EditProductSaveApiNormalizedResponse,
    ): EditProductSaveApiSuccessAction => ({
        type: EDIT_PRODUCT_SAVE_API_SUCCESS,
        productId,
        data,
        response,
    }),
    failure: (productId: number, data: ProductFormData, error: any): EditProductSaveApiFailureAction => ({
        type: EDIT_PRODUCT_SAVE_API_FAILURE,
        productId,
        data,
        error,
    }),
};

export const EDIT_PRODUCT_SAVE = 'EDIT_PRODUCT_SAVE';

export interface EditProductSaveAction extends EditProductSaveApiAction {
    readonly type: typeof EDIT_PRODUCT_SAVE;
}

export const editProductSave = (productId: number, data: ProductFormData): EditProductSaveAction => ({
    type: EDIT_PRODUCT_SAVE,
    productId,
    data,
});

export const EDIT_PRODUCT_SELECT_CATEGORY = 'EDIT_PRODUCT_SELECT_CATEGORY';

export interface EditProductSelectCategoryAction extends Action {
    readonly type: typeof EDIT_PRODUCT_SELECT_CATEGORY;
    readonly category: string;
}

export const editProductSelectCategory = (category: string): EditProductSelectCategoryAction => ({
    type: EDIT_PRODUCT_SELECT_CATEGORY,
    category,
});
